import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'nominas/seguro-issste-registro-cuenta-contable-pasivo-patronal/';

/**
 * GET Cuentas Contables Pasivo Patronal ISSSTE
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablesPasivoPatronalISSSTE = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Cuenta Contable Pasivo Patronal ISSSTE
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCuentaContablePasivoPatronalISSSTE = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Cuenta Contable Pasivo Patronal ISSSTE
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContablePasivoPatronalISSSTE = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta Contable Pasivo Patronal ISSSTE
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContablePasivoPatronalISSSTE = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta Contable Pasivo Patronal ISSSTE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCuentaContablePasivoPatronalISSSTE = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
